export enum EmergencyType {
  MATERNAL = 'MATERNAL',
  NEONATAL = 'NEONATAL',
}
